<template>
    <!-- 卫生经济分析与监管 -->
    <productSchema :config="config"></productSchema>
</template>

<script>
import { config } from './js/medical_group_sanitation'
import productSchema from '../common/product_schema.vue'
export default {
    name: '',
    components: { productSchema },
    data() {
        return {
            config: config,
        };
    },
    computed: {
    },
    watch: {
    },
    methods: {

    },
};
</script>

<style scoped lang="less"></style>
